export default __webpack_public_path__ + "static/media/Control_3_Thermocycler.4627574b.svg";